import { Badge } from '@radix-ui/themes';
import { t } from 'i18next';
import { PitcherHand } from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const PitcherHandBadge = (props: { value: PitcherHand | undefined }) => {
  const isLeft = props.value === PitcherHand.LHP;

  if (!props.value) {
    return null;
  }

  return (
    <Badge color={isLeft ? RADIX.COLOR.LEFT : RADIX.COLOR.RIGHT}>
      {t(isLeft ? 'common.lhp' : 'common.rhp')}
    </Badge>
  );
};
